import React, { useMemo } from 'react';
import DialogComponent from '@ui/components/Dialog/Dialog.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    deviceName,
    serverError,
    demoModeError,
    onConfirmClick,
    onCancelClick,
    onBtnKeyDown,
}: IProps) => {
    const getWord = useDictionary();

    const alertMessage = useMemo(() => {
        if (serverError) return 'serverError';
        else if (demoModeError) return 'demoModeError';
        else return '';
    }, [serverError, demoModeError]);

    return (
        <>
            <DialogComponent
                className="device-delete"
                alertText={alertMessage}
                loading={loading}
                lang={lang}
                title={`${getWord(
                    'confirmDeviceDeleteWarning',
                )} "${deviceName}"?`}
                onConfirmClick={onConfirmClick}
                onCancelClick={onCancelClick}
                onBtnKeyDown={onBtnKeyDown}
            />
        </>
    );
};

const DeviceDeleteComponent = React.memo(Component);

export default DeviceDeleteComponent;
